// Styles for CustomSelectBlock  go here.
import styled from 'styled-components';

export const StyledCustomSelectBlock = styled.div`
  display: flex;
  .custom-drop-styles {
    align-items: baseline;
  }
  &.hws-custom-select-focus {
    button:focus,
    button:focus-visible {
      outline: 2px solid currentColor;
      outline-offset: 2px;
      border-radius: 2px;
    }
  }
`;
